export const parseErrorMessage = body => {
  if (!body.fields) return body.message
  return Object.values(body.fields)
    .map(m => m)
    .join(', ')
}
